import styled from 'styled-components';

import { palettes, tokens } from '../theme/tokens';

export type CountVariant = 'count' | 'zero' | 'brand' | 'warning';

const variantStyle = (variant: CountVariant, primary: string) => {
	if (variant === 'zero') {
		return {
			background: palettes.heatherGray['200'],
			color: tokens.text.secondary,
			border: tokens.border.strong,
		};
	}

	if (variant === 'brand') {
		return {
			background: tokens.surface.white,
			color: tokens.brand.text,
			border: tokens.brand.border,
		};
	}

	if (variant === 'warning') {
		return {
			background: tokens.warning.icon,
			color: tokens.text.primary,
			border: 'transparent',
		};
	}

	return {
		background: primary,
		color: tokens.text.inverse,
		border: 'transparent',
	};
};

const Container = styled.span<{ $variant: CountVariant }>`
	display: inline-flex;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
	min-width: 20px;
	height: 20px;
	padding: 6px;
	border-radius: ${tokens.radius.md}px;
	border: 1px solid ${(props) => variantStyle(props.$variant, props.theme.colors.primary).border};
	background: ${(props) => variantStyle(props.$variant, props.theme.colors.primary).background};
	color: ${(props) => variantStyle(props.$variant, props.theme.colors.primary).color};
	font-family: ${tokens.typography.fontFamily};
	font-size: 11px;
	font-weight: ${tokens.typography.weights.semibold};
	line-height: 1;
	text-align: center;
	white-space: nowrap;
	flex-shrink: 0;
	text-box-trim: trim-both;
	text-box-edge: cap alphabetic;
`;

function resolveVariant(count: number, variant?: CountVariant): CountVariant {
	if (variant) return variant;
	if (count === 0) return 'zero';
	return 'count';
}

export function Count(props: { count: number; variant?: CountVariant; selected?: boolean }) {
	const variant = resolveVariant(props.count, props.variant);

	return <Container $variant={variant}>{variant === 'zero' ? 0 : props.count}</Container>;
}
